'use strict'
const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  apiUrl : '"https://test30bjbwy.epailive.com/admin"'
  //apiUrl: '"http://192.168.5.101/admin"' //开发环境接口路径
  //apiUrl: '"http://123.56.50.236/admin"' //开发环境接口路径
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = dhIU
// module chunks = 1